import { render, staticRenderFns } from "./tsflfgzc.vue?vue&type=template&id=492856d8&scoped=true"
import script from "./tsflfgzc.vue?vue&type=script&lang=js"
export * from "./tsflfgzc.vue?vue&type=script&lang=js"
import style0 from "./tsflfgzc.vue?vue&type=style&index=0&id=492856d8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492856d8",
  null
  
)

export default component.exports